// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3CcU6","bigColWidth":"Table_bigColWidth__3jv9n","biggerColWidth":"Table_biggerColWidth__368Py","row":"Table_row__mV-u0","col":"Table_col__oYO42"};